'use client';

import { X, Check } from 'lucide-react';
import { useEffect } from 'react';

interface ToastProps {
    message: string;
    type: 'success' | 'error';
    onClose?: () => void;
}

export function Toast({ message, type, onClose }: ToastProps) {
    return (
        <div className="animate-in slide-in-from-right-5 fade-in duration-300 pointer-events-auto mb-3">
            <div
                className={`px-4 py-3 rounded-lg shadow-lg text-white font-medium flex items-center gap-3 min-w-[300px] justify-between ${type === 'success' ? 'bg-green-600' : 'bg-red-600'
                    }`}
            >
                <div className="flex items-center gap-3">
                    <span className="flex-shrink-0">
                        {type === 'success' ? <Check size={18} /> : <X size={18} />}
                    </span>
                    <span className="text-sm">{message}</span>
                </div>
                {onClose && (
                    <button onClick={onClose} className="opacity-70 hover:opacity-100 transition-opacity">
                        <X size={16} />
                    </button>
                )}
            </div>
        </div>
    );
}
